<script setup>
import logoIntel from "../../../../img/institucional/Logo_0002_intel.jpg";
import logolibbs from "../../../../img/institucional/Logo_0004_Logo_libbs.jpg";
import logoSap from "../../../../img/institucional/Logo_0003_467_sap.jpg";
import logoAtento from "../../../../img/institucional/Logo_0000_LOGO_ATENTO.jpg";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const modules = [Autoplay, Navigation, Pagination];

const testimonials = [
    {src: logoIntel, title: 'Isabela', description: "A Creative nos ajudou a potencializar nossa imagem de marca em eventos com brindes diferenciados e cool. Quando recebemos o catálogo é sempre uma boa surpresa! Os formatos são criativos, funcionais e mostram a qualidade dos brindes da melhor forma possível: utilizando-os no dia a dia."},
    {src: logolibbs, title: 'Leonardo', description: "O atendimento na venda e no pós-vendas da Creative é excelente. A Creative tem brindes inovadores e de boa qualidade, além da parceria com prazos apertados. Eu estive na produção e vi o cuidado que a Creative tem quanto à qualidade do produto e com a nossa logomarca na gravação, um dos pontos fortes da Creative."},
    {src: logoSap, title: 'Maximiliano', description: "A Creative Design é um verdadeiro parceiro de negócios para toda a área de marketing. Em diferentes empresas onde trabalhei na área de marketing, sempre contei com eles para trazerem ideias inovadoras para diferentes projetos e ações de marketing. Sempre com produtos de qualidade, entregas rápidas e pontuais. Os representantes são profissionais e parceiros com quem posso contar."},
    {src: logoAtento, title: 'Valesca', description: "Quando adquiri um produto da Creative pela primeira vez, nem todos acreditavam na qualidade dos produtos, mas até hoje todos se lembram do que ganharam e comentam da durabilidade dos produtos. Fico feliz ao receber os catálogos por ver as novidades e como os produtos da Creative se destacam em comparação com os de outros fornecedores."}
]

</script>

<template>
    <v-sheet class="mb-10">
        <div class="d-flex justify-center align-center i-testimonial mb-5">
            <p>Depoimentos</p>
        </div>
        <div class="d-flex justify-center align-center">
            <v-col class="d-flex justify-center align-center ">
                <div class="swiper-container">
                    <swiper
                        :modules="modules"
                        :slides-per-view="3"
                        :autoplay="{
                            delay: 15000,
                            disableOnInteraction: false
                        }"
                        :pagination="{
                            clickable: true,
                            dynamicBullets: false
                        }"
                        :loop="true"
                        :breakpoints="{
                            320: {slidesPerView: 1},
                            640: {slidesPerView: 1},
                            768: {slidesPerView: 2},
                            1024: {slidesPerView: 3}
                        }"
                        class="clients-swiper"
                    >
                        <swiper-slide v-for="(logo, index) in testimonials" :key="index">
                            <v-card elevation="0" class="brand-card align-center mr-10">
                                <v-card-item>
                                    <div class="d-flex align-center justify-center">
                                        <v-img :src="logo.src" contain height="150"/>
                                    </div>
                                </v-card-item>
                                <v-card-text class="mb-2 mt-2">
                                    {{logo.description}}
                                </v-card-text>
                                <v-card-subtitle class="d-flex justify-end align-baseline card-subtitle-bottom">
                                    {{logo.title}}
                                </v-card-subtitle>
                            </v-card>
                        </swiper-slide>

                    </swiper>
                </div>
            </v-col>
        </div>
    </v-sheet>
</template>

<style scoped>
.i-testimonial p {
    font-size: 3rem;
    font-weight: bold;
    color: #000;
}

.swiper-container {
    width: 100%;
    max-width: 1200px;
    position: relative;
}

.clients-swiper {
    padding: 20px 0 50px 0;
    width: 100%;
}

.brand-card {
    border: 2px solid #d4d4d4;
    border-radius: 10px;
    padding: 10px;
    max-width: 350px;
    min-height: 450px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    margin: 0 auto;
}

.card-subtitle-bottom {
    position: absolute;
    bottom: 16px;
    right: 16px;
    left: 16px;
}

.brand-card .v-card-text {
    padding-bottom: 50px !important;
}

/* Customização da paginação */
:deep(.swiper-pagination-bullet) {
    display: none;
}

/* Responsividade adicional */
@media (max-width: 960px) {
    .i-testimonial p {
        font-size: 2.5rem;
    }

    .brand-card {
        min-height: 400px;
        max-width: 300px;
    }
}

@media (max-width: 640px) {
    .i-testimonial p {
        font-size: 2rem;
    }

    .swiper-container {
        width: 95%;
    }

    .brand-card {
        min-height: 350px;
        max-width: 280px;
    }
}

@media (max-width: 480px) {
    .i-testimonial p {
        font-size: 1.8rem;
    }

    .brand-card {
        min-height: 300px;
        max-width: 250px;
        padding: 5px;
    }

    .brand-card .v-card-text {
        font-size: 0.9rem;
        padding: 10px !important;
    }
}
</style>
